export class Fancybox {

    constructor() {
        this.initFancybox();
    }

    initFancybox() {
        $('[data-role="fancybox"]').fancybox();
    }
}



// WEBPACK FOOTER //
// ./src/Frontend/Themes/Custom/src/Js/Utilities/Fancybox.js